import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import {
  fetchObalMaterialuNrSrInitData,
} from '../../../../client/pracovnyKrok/sprievodnyDokument/obalMaterialuInitDataClient';
import { ObalMaterialuNrSr } from '../../../../model/sprievodnyDokument/obalMaterialu/ObalMaterialuNrSr';

interface ReturnType {
  obalInitData: ObalMaterialuNrSr;
  initDataStatus: ClientStatus;
}

export default (type: string, year: number, index: number): ReturnType => {
  const {
    data: obalInitData,
    status: initDataStatus,
  } = useClientFetch(fetchObalMaterialuNrSrInitData, [type, year, index], []);
  return {
    obalInitData,
    initDataStatus,
  };
};
